module.exports = __webpack_public_path__ + "static/media/minus_circle.c3159f63.svg";